module.exports = __webpack_public_path__ + "img/ic_12_switch.95dea043.svg";